import { Chip } from 'primereact/chip';
import React from 'react';

export const getRole = (role: string) => {
    if (role === 'agent') return 'agent';
    else if (role === 'Supervisor 1' || role === 'Supervisor 2') return 'supervisor';
    else if (role === 'Manager 1' || role === 'Manager 2') return 'manager';
    else if (
        role !== 'Non-Manager' &&
        role !== 'Supervisor 1' &&
        role !== 'Supervisor 2' &&
        role !== 'Manager 1' &&
        role !== 'Manager 2'
    )
        return 'other';
    else return '';
};
export const allowExpansion = (rowData: any) => {
    if (rowData) return true;
    else return false;
};
export const statusBodyTemplate = (rowData: any) => {
    return (
        <div>
            {rowData.coaching_to_do_status_id === 1 && (
                <Chip label="To Do" style={{ backgroundColor: '#FDD444' }} />
            )}
            {rowData.coaching_to_do_status_id === 2 && (
                <Chip label="In Progress" style={{ backgroundColor: '#3299ff', color: 'white' }} />
            )}
            {rowData.coaching_to_do_status_id === 3 && (
                <Chip label="Done" style={{ backgroundColor: '#82DD55', color: 'white' }} />
            )}
            {rowData.coaching_to_do_status_id === 4 && (
                <Chip label="Needs Help" style={{ backgroundColor: '#E23636', color: 'white' }} />
            )}
        </div>
    );
};
export const dueBodyTemplate = (rowData: any) => {
    if (rowData.due_date) {
        const dueDate = new Date(rowData.due_date + 'Z'); // Assuming the due_date is in UTC

        const day = dueDate.getUTCDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(dueDate);
        const year = dueDate.getUTCFullYear();

        const formattedDueDate = `${day}-${month}-${year}`;

        return <div>{formattedDueDate}</div>;
    } else {
        return <div>no Date</div>;
    }
};
export const GetTeamOptions = (role: string) => {
    const teamOptions: any = [];
    teamOptions.push({ name: 'My To Do', code: 'mytodo' });
    if (role !== 'Non-Manager')
        teamOptions.push({ name: 'My Team', code: 'myteam' },{ name: 'Search', code: 'search' });
    return teamOptions;
}
